module.exports = __webpack_public_path__ + "static/img/heze-index.059eb7fc.jpg";